// Shared helpers for "internal analytics" tagging.
// Batch 0: helpers only (no behavior change until wired in).

export const INTERNAL_ANALYTICS_KEY = 'SKINNY_INTERNAL_ANALYTICS';

export function isInternalAnalyticsEnabled() {
  try {
    return (typeof window !== 'undefined' &&
      window.localStorage &&
      window.localStorage.getItem(INTERNAL_ANALYTICS_KEY) === '1');
  } catch (_) {
    return false;
  }
}

export function getTrafficBucket() {
  return isInternalAnalyticsEnabled() ? 'internal' : 'external';
}

export function setInternalAnalyticsEnabled(enabled) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return;
    window.localStorage.setItem(INTERNAL_ANALYTICS_KEY, enabled ? '1' : '0');
  } catch (_) {
    // ignore write failures (private mode / blocked storage)
  }
}

/**
 * Check URL for ?internal=1 or ?internal=0, apply to localStorage, and strip param.
 * Call once on page/app init. Returns true if a change was made.
 */
export function applyInternalParamFromUrl() {
  try {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search);
    const val = params.get('internal');
    if (val === null) return false; // param not present
    if (val === '1') {
      setInternalAnalyticsEnabled(true);
    } else if (val === '0') {
      setInternalAnalyticsEnabled(false);
    } else {
      return false; // unrecognized value; ignore
    }
    // Strip the param from URL to avoid polluted links
    params.delete('internal');
    const newSearch = params.toString();
    const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
    return true;
  } catch (_) {
    return false;
  }
}

